<template>
  <RevContainer>
    <template v-if="isPending">
      <RelatedContentSkeleton v-for="index in 2" :key="index" class="mt-48" />
    </template>
    <template v-else>
      <ArticleCardsCarousel
        :articles="relatedArticles"
        class="mt-48 text-left"
        :title="i18n(translations.relatedArticlesTitle)"
      />
      <ArticleCardsCarousel
        :articles="relatedComparePages"
        class="mt-48 text-left"
        :title="i18n(translations.relatedComparePagesTitle)"
      />
    </template>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useAsyncData, useRequestURL } from '#imports'
import { computed } from 'vue'

import ArticleCardsCarousel from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCardsCarousel.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import { useFetchInternalLinkCards } from '../../../composables/useFetchInternalLinkCards/useFetchInternalLinkCards'
import RelatedContentSkeleton from '../RelatedContentSkeleton/RelatedContentSkeleton.vue'

import translations from './RelatedContent.translations'

const i18n = useI18n()
const { pathname } = useRequestURL()
const fetchInternalLinkCards = useFetchInternalLinkCards()
const { data, pending: isPending } = useAsyncData(
  `models-comparison-related-content-${pathname}`,
  fetchInternalLinkCards,
)
const relatedArticles = computed(
  () => data.value?.comparePageRelatedArticles ?? [],
)
const relatedComparePages = computed(
  () => data.value?.comparePageRelatedComparePages ?? [],
)
</script>
